import { useQuery } from '@tanstack/react-query';
import { getSections, getSectionById, getSectionCategories } from './section.api';
import { sectionKeys } from './section.queryKeys';

export const useGetSectionsQuery = () => {
  return useQuery({
    queryKey: sectionKeys.list(),
    queryFn: getSections,
  });
};

export const useGetSectionByIdQuery = (sectionId: string) => {
  return useQuery({
    queryKey: sectionKeys.detail(sectionId),
    queryFn: () => getSectionById(sectionId),
    enabled: !!sectionId,
  });
};

export const useGetSectionCategoriesQuery = (sectionId: string) => {
  return useQuery({
    queryKey: sectionKeys.categories(sectionId),
    queryFn: () => getSectionCategories(sectionId),
    enabled: !!sectionId,
  });
};
